var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderLogoDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83.617,
    height: 30.105,
    viewBox: "0 0 83.617 30.105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e84f6b;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1210.052 -1015.549)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1210.052 1015.549)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1227.078,1029.139h-.784a.844.844,0,0,0-.805.6l-2.362,8.023-2.753-8.057a.839.839,0,0,0-.794-.568h-1.164a.839.839,0,0,0-.8.572l-2.706,8.051-2.384-8.023a.845.845,0,0,0-.8-.6h-.834a.839.839,0,0,0-.8,1.1l3.411,10.5a.838.838,0,0,0,.8.579h1.1a.837.837,0,0,0,.8-.578l2.653-8.1,3,8.126a.843.843,0,0,0,.788.548h1.043a.838.838,0,0,0,.8-.581l3.388-10.5a.839.839,0,0,0-.8-1.1Z",
    transform: "translate(-1210.052 -1021.908)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1257.205,1030.261a5.141,5.141,0,0,0-1.847-1.258,6.242,6.242,0,0,0-2.34-.43,6.556,6.556,0,0,0-2.492.468,5.888,5.888,0,0,0-1.98,1.316,6.03,6.03,0,0,0-1.3,2.03,6.979,6.979,0,0,0-.467,2.577,7.189,7.189,0,0,0,.428,2.484,6.01,6.01,0,0,0,1.224,2.03,5.84,5.84,0,0,0,1.941,1.369,6.317,6.317,0,0,0,2.573.508,7.567,7.567,0,0,0,3-.558,5.77,5.77,0,0,0,1.953-1.438.826.826,0,0,0,.213-.628.844.844,0,0,0-.322-.6l-.506-.395a.844.844,0,0,0-1.124.085,4.068,4.068,0,0,1-3.211,1.291,3.4,3.4,0,0,1-1.395-.283,3.569,3.569,0,0,1-1.114-.77,4.084,4.084,0,0,1-1-1.776.4.4,0,0,1,.071-.346.413.413,0,0,1,.329-.162h8.132a.841.841,0,0,0,.839-.842,8.064,8.064,0,0,0-.414-2.67A5.652,5.652,0,0,0,1257.205,1030.261Zm-1.1,3.281a.413.413,0,0,1-.321.153h-5.9a.414.414,0,0,1-.337-.172.391.391,0,0,1-.059-.351,3.393,3.393,0,0,1,.967-1.513,3.6,3.6,0,0,1,2.493-.849,3.329,3.329,0,0,1,2.411.844,2.958,2.958,0,0,1,.832,1.553A.4.4,0,0,1,1256.1,1033.542Z",
    transform: "translate(-1227.236 -1021.643)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2.388,
    height: 19.411,
    rx: 1.194,
    transform: "translate(35.039 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1299.105,1024.3a5.865,5.865,0,0,0-2.019-1.343,6.888,6.888,0,0,0-2.6-.48,5.466,5.466,0,0,0-2.443.55,5.937,5.937,0,0,0-1.612,1.174v-7.814a.84.84,0,0,0-.839-.839h-.709a.841.841,0,0,0-.839.839v17.733a.84.84,0,0,0,.839.839h.709a.84.84,0,0,0,.839-.839v-.823a5.062,5.062,0,0,0,1.473,1.245,5.674,5.674,0,0,0,2.882.719,6.03,6.03,0,0,0,2.4-.482,5.869,5.869,0,0,0,1.94-1.342,6.294,6.294,0,0,0,1.287-2.027,7.135,7.135,0,0,0,0-5.081A6.2,6.2,0,0,0,1299.105,1024.3Zm-.77,4.569a4.8,4.8,0,0,1-.276,1.646,3.755,3.755,0,0,1-2.045,2.187,4.321,4.321,0,0,1-3.266,0,3.753,3.753,0,0,1-2.045-2.187,5.052,5.052,0,0,1,0-3.293,3.752,3.752,0,0,1,2.045-2.187,4.315,4.315,0,0,1,3.266,0,3.754,3.754,0,0,1,2.044,2.187A4.8,4.8,0,0,1,1298.335,1028.87Z",
    transform: "translate(-1246.543 -1015.549)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1327.5,1030.261a5.135,5.135,0,0,0-1.846-1.258,6.238,6.238,0,0,0-2.34-.43,6.553,6.553,0,0,0-2.492.468,5.887,5.887,0,0,0-1.98,1.316,6.029,6.029,0,0,0-1.3,2.03,6.984,6.984,0,0,0-.467,2.577,7.189,7.189,0,0,0,.427,2.484,6.022,6.022,0,0,0,1.224,2.03,5.837,5.837,0,0,0,1.942,1.369,6.315,6.315,0,0,0,2.573.508,7.565,7.565,0,0,0,3-.558,5.775,5.775,0,0,0,1.953-1.438.829.829,0,0,0,.213-.628.847.847,0,0,0-.322-.6l-.507-.395a.843.843,0,0,0-1.124.085,4.071,4.071,0,0,1-3.212,1.291,3.4,3.4,0,0,1-1.394-.283,3.573,3.573,0,0,1-1.114-.77,4.09,4.09,0,0,1-1-1.776.4.4,0,0,1,.071-.346.413.413,0,0,1,.329-.162h8.133a.841.841,0,0,0,.839-.842,8.07,8.07,0,0,0-.413-2.67A5.65,5.65,0,0,0,1327.5,1030.261Zm-1.1,3.281a.412.412,0,0,1-.321.153h-5.9a.413.413,0,0,1-.336-.172.388.388,0,0,1-.059-.351,3.4,3.4,0,0,1,.967-1.513,3.6,3.6,0,0,1,2.493-.849,3.328,3.328,0,0,1,2.411.844,2.963,2.963,0,0,1,.832,1.553A.4.4,0,0,1,1326.4,1033.542Z",
    transform: "translate(-1260.127 -1021.643)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1347.65,1035.782h8.133a.841.841,0,0,0,.839-.842,8.052,8.052,0,0,0-.414-2.67,5.659,5.659,0,0,0-1.188-2.009,5.136,5.136,0,0,0-1.847-1.258,6.242,6.242,0,0,0-2.34-.43,6.553,6.553,0,0,0-2.492.468,5.877,5.877,0,0,0-1.98,1.316,6.025,6.025,0,0,0-1.3,2.03,6.976,6.976,0,0,0-.467,2.577,7.2,7.2,0,0,0,.427,2.484,6.022,6.022,0,0,0,1.224,2.03,5.828,5.828,0,0,0,1.941,1.369,6.316,6.316,0,0,0,2.573.508,7.568,7.568,0,0,0,3-.558,5.77,5.77,0,0,0,1.953-1.437.829.829,0,0,0,.213-.628.845.845,0,0,0-.322-.6l-.506-.395a.844.844,0,0,0-1.124.085,4.069,4.069,0,0,1-3.212,1.291,3.407,3.407,0,0,1-1.395-.283,3.577,3.577,0,0,1-1.114-.77,4.079,4.079,0,0,1-1-1.776.4.4,0,0,1,.071-.346A.413.413,0,0,1,1347.65,1035.782Zm6.267-2.24a.411.411,0,0,1-.321.154h-5.9a.412.412,0,0,1-.336-.172.39.39,0,0,1-.06-.351,3.4,3.4,0,0,1,.967-1.514,3.6,3.6,0,0,1,2.493-.849,3.326,3.326,0,0,1,2.411.844,2.964,2.964,0,0,1,.832,1.552A.4.4,0,0,1,1353.917,1033.542Z",
    transform: "translate(-1273.004 -1021.643)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1274.34 1040.49)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1356.364,1062.519c.022-.01-.1-.08-.125-.1C1356.248,1062.466,1356.4,1062.538,1356.364,1062.519Z",
    transform: "translate(-1342.741 -1062.423)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1356.584,1063.43l-.044-.04.085.128Z",
    transform: "translate(-1342.882 -1062.875)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1356.233,1063.743c.207.134.045-.117.15-.106l.05.027-.138-.142C1356.275,1063.594,1356.317,1063.749,1356.233,1063.743Z",
    transform: "translate(-1342.738 -1062.937)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1355.283,1063.5c.077.057.036.08.048-.006l-.022-.011A.052.052,0,0,1,1355.283,1063.5Z",
    transform: "translate(-1342.294 -1062.917)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1355.305,1063.457c.016-.027-.074-.039,0,0Z",
    transform: "translate(-1342.291 -1062.895)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1355.1,1063.62l-.033-.089c-.047-.032-.081-.015-.1-.053C1354.967,1063.54,1355.013,1063.573,1355.1,1063.62Z",
    transform: "translate(-1342.144 -1062.917)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1355.379,1063.99l-.01-.041C1355.349,1063.935,1355.339,1063.933,1355.379,1063.99Z",
    transform: "translate(-1342.326 -1063.133)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1355.342,1063.793l.022.086c.032.023.091.078,0-.035C1355.409,1063.9,1355.365,1063.842,1355.342,1063.793Z",
    transform: "translate(-1342.322 -1063.064)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1355.428,1063.781c.055.02.1.019.134.109C1355.6,1063.806,1355.459,1063.7,1355.428,1063.781Z",
    transform: "translate(-1342.362 -1063.045)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1356.559,1064.222l.077.019-.043-.077C1356.614,1064.2,1356.5,1064.174,1356.559,1064.222Z",
    transform: "translate(-1342.883 -1063.237)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1354.706,1063.917c.034.04.106.093.154.139l-.018-.064A.294.294,0,0,1,1354.706,1063.917Z",
    transform: "translate(-1342.024 -1063.122)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1355,1064.178l.025.1C1355.06,1064.254,1355.037,1064.218,1355,1064.178Z",
    transform: "translate(-1342.16 -1063.244)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1355.689,1064.235l-.079-.189.07.2Z",
    transform: "translate(-1342.447 -1063.182)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1354.4,1064.031l-.061-.108.086.167Z",
    transform: "translate(-1341.852 -1063.125)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1354.178,1064.149c-.05-.089-.128-.113-.152-.173a.48.48,0,0,0,.052.192C1354.073,1064.119,1354.1,1064.11,1354.178,1064.149Z",
    transform: "translate(-1341.705 -1063.15)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1354.164,1064.449a.664.664,0,0,0-.037-.113A.4.4,0,0,0,1354.164,1064.449Z",
    transform: "translate(-1341.753 -1063.318)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1354.782,1064.35a.379.379,0,0,0-.127-.086l.112.1Z",
    transform: "translate(-1342 -1063.284)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1354.837,1064.45l0,0-.036.021Z",
    transform: "translate(-1342.067 -1063.37)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1354.9,1064.421l0,0C1354.905,1064.433,1354.909,1064.436,1354.9,1064.421Z",
    transform: "translate(-1342.112 -1063.358)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1355.412,1064.4c.038.08.054.188.183.235C1355.54,1064.547,1355.467,1064.52,1355.412,1064.4Z",
    transform: "translate(-1342.354 -1063.348)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1355.143,1064.548l.062-.01a.4.4,0,0,1-.089-.1Z",
    transform: "translate(-1342.216 -1063.365)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1355.158,1064.7l-.012-.052-.023,0Z",
    transform: "translate(-1342.219 -1063.464)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1354.482,1064.644a.094.094,0,0,1-.009.107.122.122,0,0,0,.1-.021C1354.545,1064.691,1354.5,1064.619,1354.482,1064.644Z",
    transform: "translate(-1341.915 -1063.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1354.69,1064.572v.01C1354.7,1064.589,1354.707,1064.591,1354.69,1064.572Z",
    transform: "translate(-1342.016 -1063.428)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1354.064,1065.157l.02.019-.014-.021Z",
    transform: "translate(-1341.724 -1063.701)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1354.678,1064.779c.035.007.022-.029,0-.073a.087.087,0,0,1-.023.055C1354.669,1064.778,1354.678,1064.789,1354.678,1064.779Z",
    transform: "translate(-1342.001 -1063.491)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1354.163,1064.723a.571.571,0,0,0,.08.04C1354.205,1064.733,1354.143,1064.69,1354.163,1064.723Z",
    transform: "translate(-1341.768 -1063.494)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1354.618,1064.526l0-.007C1354.59,1064.5,1354.6,1064.511,1354.618,1064.526Z",
    transform: "translate(-1341.975 -1063.399)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1354.633,1064.541a.6.6,0,0,0,.036.088.158.158,0,0,0,0-.062A.317.317,0,0,1,1354.633,1064.541Z",
    transform: "translate(-1341.99 -1063.414)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1354.563,1065.993c-.075-.114-.1-.255.035-.172a2.259,2.259,0,0,0-.5-.626.318.318,0,0,1,.072.19c.057.049.2.067.234.193-.017.1-.077,0-.146-.039.125.12.067.255.222.45l.005-.11C1354.511,1065.91,1354.528,1065.975,1354.563,1065.993Z",
    transform: "translate(-1341.741 -1063.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1354.121,1064.989l.007-.026a.491.491,0,0,1-.169-.1.374.374,0,0,0,.061.157l.094-.048Z",
    transform: "translate(-1341.675 -1063.563)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1354.351,1064.881c.079.126.075.208.2.314.046-.048-.04-.125-.05-.2-.059.091-.028-.082-.139-.1a.111.111,0,0,1,.019-.063.312.312,0,0,1-.083-.021l.007.006h0l0,0c.015.012.023.02.012.014v0l.031.046c-.042-.006-.027-.027-.031-.046l-.013-.018h0l-.029.124C1354.305,1064.943,1354.324,1064.923,1354.351,1064.881Z",
    transform: "translate(-1341.823 -1063.539)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1356.065,1065.33a.143.143,0,0,1-.027-.023C1356.045,1065.325,1356.052,1065.336,1356.065,1065.33Z",
    transform: "translate(-1342.647 -1063.772)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1355.66,1065.083c-.008-.021-.043-.069-.013-.074.047.017.048.052.082.086a.167.167,0,0,0-.118-.133l.008.02a.629.629,0,0,1-.242-.128A2.478,2.478,0,0,0,1355.66,1065.083Z",
    transform: "translate(-1342.339 -1063.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1355.175,1065.194l-.02.114.117.068-.051-.057C1355.278,1065.308,1355.208,1065.243,1355.175,1065.194Z",
    transform: "translate(-1342.234 -1063.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1353.895,1064.942l-.084-.133.093.207Z",
    transform: "translate(-1341.605 -1063.539)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1353.761,1065.108l-.075-.113.023.083Z",
    transform: "translate(-1341.547 -1063.626)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1342.261,1071.2l-.032.037A.114.114,0,0,0,1342.261,1071.2Z",
    transform: "translate(-1336.186 -1066.529)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1342.687,1071.182l.008-.067C1342.683,1071.152,1342.678,1071.179,1342.687,1071.182Z",
    transform: "translate(-1336.398 -1066.49)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1349.106,1067.2c-.07-.111-.161-.289-.116-.143l.051.14C1349.059,1067.159,1349.082,1067.17,1349.106,1067.2Z",
    transform: "translate(-1339.344 -1064.563)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1345.856,1069.594l.016.044.014-.144Z",
    transform: "translate(-1337.883 -1065.731)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1345.849,1070.759l-.064-.091A.323.323,0,0,0,1345.849,1070.759Z",
    transform: "translate(-1337.85 -1066.281)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1340,1071.252l-.058.145C1340,1071.4,1339.984,1071.325,1340,1071.252Z",
    transform: "translate(-1335.115 -1066.554)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1351.962,1066.324c-.054-.038-.087-.049-.11-.046C1351.923,1066.339,1352.007,1066.44,1351.962,1066.324Z",
    transform: "translate(-1340.689 -1064.227)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1342.588,1068.242a.164.164,0,0,0-.027.089A.137.137,0,0,0,1342.588,1068.242Z",
    transform: "translate(-1336.341 -1065.146)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1351.7,1066.288c.011.011.02.015.03.024.01-.032.022-.061.051-.065C1351.725,1066.2,1351.68,1066.18,1351.7,1066.288Z",
    transform: "translate(-1340.615 -1064.195)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1332.494,1068.238c0-.007,0-.012,0-.021C1332.484,1068.234,1332.487,1068.237,1332.494,1068.238Z",
    transform: "translate(-1331.628 -1065.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1332.445,1064.686a.085.085,0,0,1,.038.021C1332.484,1064.694,1332.475,1064.686,1332.445,1064.686Z",
    transform: "translate(-1331.608 -1063.482)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1353.076,1065.543c.015-.02-.005-.016,0,0Z",
    transform: "translate(-1341.261 -1063.877)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1353.846,1066.376a.241.241,0,0,0,.03.066A.31.31,0,0,1,1353.846,1066.376Z",
    transform: "translate(-1341.622 -1064.272)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1351.99,1068.131h0C1352.006,1068.155,1352,1068.151,1351.99,1068.131Z",
    transform: "translate(-1340.752 -1065.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1353.156,1065.61a.161.161,0,0,0-.048-.022A.167.167,0,0,0,1353.156,1065.61Z",
    transform: "translate(-1341.276 -1063.904)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1353.122,1065.5h.025C1353.136,1065.482,1353.125,1065.47,1353.122,1065.5Z",
    transform: "translate(-1341.283 -1063.855)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1353.032,1065.578a.046.046,0,0,1,.04-.005.043.043,0,0,1-.016-.018A.22.22,0,0,1,1353.032,1065.578Z",
    transform: "translate(-1341.241 -1063.889)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1336.67,1069.41v-.015C1336.623,1069.444,1336.638,1069.439,1336.67,1069.41Z",
    transform: "translate(-1333.571 -1065.685)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1348.7,1070.488v-.008l0,0Z",
    transform: "translate(-1339.21 -1066.191)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1348.514,1070.254c0-.189.031-.173.071-.141l-.122-.413Z",
    transform: "translate(-1339.103 -1065.828)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1336.43,1068.093l.057.141c-.107.21-.163.128-.115.322.057-.463.285-.017.334-.484l.038.1c-.013-.005-.017.022-.03.017.074.228.092-.332.2-.259a.141.141,0,0,1,.03.161l.1-.11c.025.01.014.092-.011.081l.138-.029v.014a2.3,2.3,0,0,1,.094-.231c.031.068-.019.049-.013.108l.079-.112c.027.122-.039.238-.091.219.054.467.066-.116.211.159l-.073.058c.039.265.1.171.18.337-.02-.087-.157-.419-.072-.533.022.036.053.053.1-.04,0,.166.043.126.1.118l-.005.219c.06-.062.055-.173.09-.273.065.02.08.19.1.333.107.032-.075-.271.049-.315.088.082.149-.01.247-.144.063.074-.006.135.018.2l.047-.177c.013,0,.011.058.01.085.043-.069,0-.219.063-.281.006-.241.162.349.234.066.026.061,0,.135.009.219a1.152,1.152,0,0,0,.175-.388l.094.137a.765.765,0,0,1,.038-.525c-.028-.078-.052-.146-.067-.178l.092-.125a.527.527,0,0,1,0,.2l.014-.054a.578.578,0,0,1,.024.33l-.051-.132a1.93,1.93,0,0,0-.009.412.12.12,0,0,1,.031-.062.3.3,0,0,0,0,.091c.006.023.013-.027.025-.083l.048.242,0-.1c.052.047.106.094.16.138.077-.258.12-.63.26-.75a2.248,2.248,0,0,0,.058.5c-.073-.217-.112.111-.2.077.046.018.049.12.042.156l.124-.222c.02.173.05.125.1.191-.077-.337.079-.241.123-.353.021.113.024.232-.054.214.122.245.045-.412.157-.21-.017.006-.03-.01-.028.05.025-.109.139-.047.133.056l-.017.005a.288.288,0,0,0,.323-.354c.009.037.055.348.059.407q.011-.5,0-1c.035.249.236.815.168.977.036.028.081.061.121-.04a1.084,1.084,0,0,1-.107-.371,1.694,1.694,0,0,0,.226.344c-.041-.045-.1-.436-.054-.434.007.059.1.376.089.42l.019-.4a1.194,1.194,0,0,0,.128.418c-.031-.071.1-.017.121-.062l-.071-.074c.144.023-.017-.559.106-.574.008.081.1.482.176.51a5.85,5.85,0,0,1-.092-1.123l.054.1.037-.146a7.928,7.928,0,0,1,.079,1.195c.074.072.052.124.121.093a.134.134,0,0,1-.013.178l.192.014c-.077-.217.059-.259-.009-.442-.033.1-.071.189-.108.284-.075-.22-.092-.652.029-.654a2.784,2.784,0,0,1,.136.47c-.01-.081.061-.183.09-.134l-.009.135c.094.058,0-.327.156-.147.031,0,.183.25.14.12a7.313,7.313,0,0,1-.466-1.189,2.617,2.617,0,0,1,.292.3c.117.177.115.482.214.635a.56.56,0,0,1-.024-.168c.047.039.06.187.109.135-.077-.222.127-.032-.045-.2.032-.086.079.019.142-.019a1.261,1.261,0,0,1-.112-.584.773.773,0,0,0,.084.152c.12-.028.227.045.331-.007.034.047.114.083.136.185,0-.045-.023-.124.007-.144.152.151-.059.064.1.259-.055-.125,0-.21.011-.31-.109-.18-.123.016-.133.116a1.324,1.324,0,0,1-.14-.742c.047-.1.121.149.116.105.181-.031-.113-.514.107-.4a2.013,2.013,0,0,1,.26.428c-.032.1-.159-.045-.2-.013l.1.045c.009.065-.014.133-.063.1.122.121.275-.12.473-.058a.309.309,0,0,0-.064-.194l-.024.044c-.11-.108-.038-.216-.12-.248,0-.117-.045-.292.065-.262l.127.169c-.035-.051-.111-.077-.094-.011-.025-.1.256.172.135-.078l-.125-.092c-.012-.119-.083-.34.008-.321-.143-.155,0,.028-.175-.147.2.229-.144.08.086.31-.195-.21-.135-.054-.315-.224.038.057.089.1.026.1a.564.564,0,0,1,.022.059l-.006,0,.007.005c0,.01,0,.012,0,0a.384.384,0,0,1,.079.074c.063.152-.018.192,0,.278-.046-.011-.028-.075-.082-.129l.024.128c-.083-.13-.205-.178-.185-.294l-.063.028c-.078-.055-.141-.059-.139.015-.043-.013.012.19-.022.07-.015.046-.032.091-.05.135l-.019-.033c-.1.029-.087.327-.317.131-.016.051-.029.113-.1.1l-.065-.117c-.024.061-.18-.068-.143.067-.186-.313-.231.016-.332-.016l.059.164c-.056.01-.09.073-.133.163l.057.143c-.016.14-.187-.049-.271,0-.012-.058.016-.051.043-.024-.214-.29-.158.313-.335.1-.01.061-.034.049-.062.017a.012.012,0,0,0,0-.01.016.016,0,0,0-.011,0c-.019-.022-.038-.049-.057-.069a.378.378,0,0,0,.052.071.156.156,0,0,0-.061.082l-.057-.156s0,0-.005.006c-.044-.051,0,.083.046.2a.443.443,0,0,0-.012.107c-.092-.25-.055.107-.16-.16.015.139-.122.136-.071.424-.01-.037-.023-.052-.007-.058-.042-.024-.083-.049-.094.039l-.061-.2-.012.293a.494.494,0,0,1-.1-.351c-.053.269-.065.112-.108.37l-.022-.134c-.031.011-.05.2-.092.093-.121-.243-.372.038-.6-.181.091.392-.111-.167-.078.142a.433.433,0,0,1-.036-.228c-.084.1-.159-.13-.2.138-.021-.093.005-.141-.011-.2-.005.021-.021.086-.036.031s.005-.081.015-.124c-.093.029-.075.316-.055.59-.064-.125-.086-.1-.107.077-.026-.088-.063-.179,0-.216-.036-.01-.222-.115-.21.1-.015-.055-.05-.013-.058.013-.08-.007-.087-.025-.164,0l.024.034c-.017.266-.062.061-.124.095v-.027c-.151-.187-.06.093-.208-.121l.012.164c-.006.354-.131-.206-.211-.068l.03.093c-.046.123-.128-.477-.17-.524-.009-.031.016-.049.029-.072-.112-.211-.015.216-.1.264-.014-.117.024-.3-.033-.318-.025-.094-.175.374-.247.149a.359.359,0,0,1-.014.246c-.066.032-.151-.346-.221-.068a.236.236,0,0,1-.007-.071c-.051.07-.161.111-.2.262,0-.567-.321.251-.272-.272l-.147.013.01-.053c-.087-.044-.135.077-.184.2-.017-.038,0-.084.01-.112-.121-.123-.134-.1-.287.137l.014-.17c-.047.091-.151-.288-.313-.121a.254.254,0,0,1,.028-.072c-.187.166-.248-.527-.432.063l-.131.126c.116.078-.08.257-.05.37-.061.022-.089-.214-.019-.23l0,.032c.1-.309-.131-.149-.074-.362-.249-.047-.434-.285-.645-.373l-.054.247-.073-.041c0-.062.037-.195.088-.167.018-.144-.13.082-.151.133-.074-.133.139-.262.108-.279l-.05,0v.031c-.07.085-.11.186-.172.151-.025-.062.032-.153.019-.168.006-.016,0-.026-.022-.016l-.086-.057-.033.2c-.078.075-.087-.046-.124.181.06-.347-.313-.259-.308-.379-.117.106-.175.076-.239.029,0,.045-.083.252-.135.2.221-.4-.026-.236.075-.557-.056.218-.191-.037-.269.273-.034-.058.077-.154.09-.269-.205.1-.194-.244-.362-.269a.623.623,0,0,1-.135.2l.087-.3c-.042.009-.211.278-.147.07-.021.047-.052.119-.081.123-.056-.208-.219-.249-.366-.326s-.272-.19-.211-.494c-.045.114-.074.106-.1.088,0,.035-.1.112-.151.176l.056-.26c-.172.149-.113-.086-.275.061h.059c-.222.143-.335.467-.565.7.25-.168-.148.458.224.222-.023.068-.087.066-.125.133.116-.086.162-.086.175.007l-.028.022c.17.1.151.257.276.464l.083-.141c.025.046,0,.093,0,.139.187-.169-.1-.09.1-.281-.145.309.262.192.09.526.061.042.086-.169.145-.127l-.039.1.087-.1c.028.044-.02.164-.065.238,0-.015-.041,0-.055,0-.011.137.171.062.17.1l-.028-.089c.221.017.365.264.633.164l.023-.074c.192-.061.064.128.234.141l-.013.014c.062-.054.115-.07.151-.046-.075.065-.006.189-.1.258.207-.073.122-.076.332-.294l-.031.125c.078-.091.105-.145.188-.144-.1.074-.031.2-.154.3.044.326.333-.168.25.239.2-.3-.06-.234.008-.289.012-.119.156-.221.188-.17.044.025-.083.452.045.495-.012-.006-.022.018-.034.012.016.1.134-.081.141.076.1-.19.071.038.17-.216l-.134.02c.089-.045.252-.325.306-.144a.567.567,0,0,1-.114.138c.005.086.077-.03.082.059-.1.255-.157.009-.3.181,0,.12.2-.14.066.126.171-.337.111.088.285-.155l-.055.154c.021-.02.073-.083.1-.073l-.11.188c.124-.15.091.191.188.118-.145-.037.024-.2,0-.329.234-.159-.023.437.2.421-.033.014-.074-.124-.012-.184a.4.4,0,0,1,.062.207c.141,0,.024-.167.1-.248-.006.2.085-.062.157-.11l-.041.161c.123.139.123-.326.224-.169l-.11.209.084-.04-.058.18c.109-.117.123-.076.187-.007.009-.119.076-.289.141-.282.024.1-.058.149.04.144-.042.1-.093.22-.1.062-.016.052-.043.1-.059.148.026.121.119.05.154.055a.061.061,0,0,1-.029-.045l.182-.2a.223.223,0,0,1-.044.155c.031-.012.065-.083.108-.089-.036.13-.059.267-.13.318l.161-.121c0,.06.039.172.013.217.061.094.226-.227.305-.109a.128.128,0,0,1,.047-.064c.086.044.146.22.279.054l.031.246c.092-.045-.045-.311.106-.386.108-.065.013.209.04.279.066-.115.176-.353.248-.147C1336.481,1068.116,1336.46,1068.078,1336.43,1068.093Zm1.051-.042c-.021.034-.064.14-.077.042C1337.433,1067.9,1337.448,1067.995,1337.481,1068.05Zm1.541-.459c-.009.056-.034.03-.065-.03C1338.974,1067.546,1338.995,1067.551,1339.022,1067.591Zm3.512-2.259,0,.008C1342.471,1065.3,1342.5,1065.318,1342.534,1065.332Zm.106.023a.151.151,0,0,0-.032-.062c.016.039,0,.051-.021.051C1342.613,1065.378,1342.637,1065.4,1342.639,1065.355Zm-8.554.652v.047C1334.035,1066.085,1334.06,1066.049,1334.086,1066.007Z",
    transform: "translate(-1330.872 -1063.423)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1345.884,1070.628a.631.631,0,0,1-.016-.089A.117.117,0,0,0,1345.884,1070.628Z",
    transform: "translate(-1337.887 -1066.22)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1340.062,1071.2l0,0c0,.01-.006.019-.008.029Z",
    transform: "translate(-1335.167 -1066.529)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1351.771,1069.474a.209.209,0,0,1-.066-.067C1351.718,1069.445,1351.739,1069.474,1351.771,1069.474Z",
    transform: "translate(-1340.62 -1065.691)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1353.355,1065.194l-.017.063c.015-.02.042.005.067.021C1353.383,1065.246,1353.344,1065.2,1353.355,1065.194Z",
    transform: "translate(-1341.384 -1063.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1355.138,1066.185c-.006-.021.013-.013.006-.034l-.048-.06A.061.061,0,0,0,1355.138,1066.185Z",
    transform: "translate(-1342.202 -1064.139)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1354.017,1065.932c.082.113.084.055.1.013,0,0,0,0-.006,0C1354.01,1065.782,1354.014,1065.857,1354.017,1065.932Z",
    transform: "translate(-1341.701 -1064.026)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1354.214,1065.969a.035.035,0,0,1,.027-.022C1354.2,1065.88,1354.22,1065.941,1354.214,1065.969Z",
    transform: "translate(-1341.794 -1064.058)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1353,1065.676c.034.022-.083-.158-.045-.114C1352.878,1065.4,1352.966,1065.8,1353,1065.676Z",
    transform: "translate(-1341.19 -1063.873)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1354.455,1066.57l-.108-.135.059.127Z",
    transform: "translate(-1341.856 -1064.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1353.929,1066.764l.077.006a.088.088,0,0,1-.017-.058C1353.954,1066.727,1353.9,1066.721,1353.929,1066.764Z",
    transform: "translate(-1341.657 -1064.429)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1354.048,1066.666a.04.04,0,0,0,.026-.052A.082.082,0,0,0,1354.048,1066.666Z",
    transform: "translate(-1341.716 -1064.384)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1354.4,1066.841l-.035-.02-.044.014Z",
    transform: "translate(-1341.843 -1064.481)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1352.778,1067.367l-.038.074c.02.056.053.08.065.047C1352.8,1067.444,1352.813,1067.413,1352.778,1067.367Z",
    transform: "translate(-1341.104 -1064.736)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1353.5,1067.88a.456.456,0,0,1-.089-.1l.1.189Z",
    transform: "translate(-1341.416 -1064.93)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1353.271,1068.232c.021.055-.017.2.06.145C1353.31,1068.321,1353.352,1068.246,1353.271,1068.232Z",
    transform: "translate(-1341.353 -1065.141)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1351.142,1068.283l.016-.009-.126-.326Z",
    transform: "translate(-1340.305 -1065.008)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1349.966,1070.389c.108.055-.038-.214.067-.136,0-.085-.085-.064-.085-.138C1349.921,1070.213,1349.881,1070.174,1349.966,1070.389Z",
    transform: "translate(-1339.782 -1066.022)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1349.977,1070.063a.488.488,0,0,0,.011-.059A.182.182,0,0,0,1349.977,1070.063Z",
    transform: "translate(-1339.811 -1065.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1332.416,1064.136l.018-.083-.061.1Z",
    transform: "translate(-1331.575 -1063.186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1331.979,1064.3l.149-.166-.163.124C1331.98,1064.257,1332.009,1064.257,1331.979,1064.3Z",
    transform: "translate(-1331.383 -1063.223)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1343.539,1071.858l.005-.054c-.009-.058-.022-.063-.049-.072Z",
    transform: "translate(-1336.778 -1066.779)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1342.129,1071.425l.013.005-.011-.2Z",
    transform: "translate(-1336.139 -1066.542)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1340.856,1071.87c.026.011.063-.03.088-.019C1340.882,1071.881,1340.878,1071.619,1340.856,1071.87Z",
    transform: "translate(-1335.544 -1066.792)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLogoDashboard);
export default __webpack_public_path__ + "static/media/header-logo-dashboard.33df4d3656f050d25f1b98ace5a0ee0b.svg";
export { ForwardRef as ReactComponent };